var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "main" }, [
        _c(
          "div",
          { staticClass: "box lottery" },
          [
            _c("Header", { ref: "header" }),
            _c("GameBanner", {
              attrs: {
                src: _vm.gameData.topBgImage,
                variant: _vm.gameData.extraFields.bannerType,
                drawProductId: _vm.gameData.extraFields.bannerDrawProductId,
              },
            }),
            _c("div", { staticClass: "item_Options" }, [
              _c(
                "div",
                { staticClass: "content" },
                [
                  _c("UserInfo", { ref: "userInfo" }),
                  _c("div", { staticClass: "position" }, [
                    _c("div", { staticClass: "lottery-ui" }, [
                      _c("div", { staticClass: "lottery-stage" }, [
                        _c(
                          "button",
                          {
                            staticClass: "rule-open-btn",
                            attrs: {
                              "aria-label": _vm.$t("lottery_rule_button"),
                            },
                            on: {
                              click: function ($event) {
                                _vm.showRulePopup = true
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("lottery_rule_button")))]
                        ),
                        _c("div", { staticClass: "points-bar" }, [
                          _c("div", { staticClass: "points-main-line" }, [
                            _vm.activityType == 1
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "copywriting-text copywriting-1",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("lottery_current_points_label")
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c("span", { staticClass: "points-label" }, [
                              _vm._v(_vm._s(_vm.amountLabel)),
                            ]),
                            _c("span", { staticClass: "points-value" }, [
                              _vm._v(_vm._s(_vm.amountValue)),
                            ]),
                          ]),
                          _vm.activityType == 1
                            ? _c(
                                "span",
                                {
                                  staticClass: "copywriting-text copywriting-2",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("lottery_points_recharge_tip")
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _c("div", { staticClass: "center-stage" }, [
                          _c(
                            "div",
                            { staticClass: "wheel-wrap" },
                            [
                              _c("div", { staticClass: "wheel-pointer" }, [
                                _c("img", {
                                  staticClass: "wheel-pointer-image",
                                  style: _vm.pointerStyle,
                                  attrs: {
                                    src: _vm.pointerUrl,
                                    alt: "pointer",
                                  },
                                }),
                                _c("img", {
                                  staticClass: "lottery-text-image",
                                  attrs: {
                                    src: require("./pointer-2.png"),
                                    alt: "",
                                  },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "lottery-text-label" },
                                  [_vm._v(_vm._s(_vm.$t("lottery_spin_label")))]
                                ),
                              ]),
                              _c("div", {
                                staticClass: "wheel-ring",
                                style: _vm.wheelBackgroundStyle,
                              }),
                              _vm._l(
                                _vm.wheelSegments,
                                function (segment, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: segment.id || index,
                                      staticClass: "wheel-prize",
                                      style: _vm.getPrizeItemStyle(index),
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "wheel-prize-image",
                                        attrs: {
                                          src: segment.image,
                                          alt: segment.label,
                                        },
                                      }),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                          _c("div", { staticClass: "action-row" }, [
                            _c(
                              "button",
                              {
                                staticClass: "draw-btn draw-btn-limit",
                                class: { "is-loading": _vm.isDrawing },
                                attrs: { "aria-label": _vm.drawButtonText },
                                on: { click: _vm.tryDraw },
                              },
                              [_vm._v(_vm._s(_vm.drawButtonText))]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "record-btn",
                                attrs: {
                                  "aria-label": _vm.$t("lottery_record_button"),
                                },
                                on: { click: _vm.openRecord },
                              },
                              [_vm._v(_vm._s(_vm.$t("lottery_record_button")))]
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                    _vm.isInitDataLoading
                      ? _c("div", { staticClass: "lottery-init-mask" }, [
                          _c("div", { staticClass: "lottery-init-loading" }),
                        ])
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ]),
            _c("Footer"),
          ],
          1
        ),
      ]),
      _c(
        "LotteryPrizePopup",
        {
          attrs: { visible: _vm.showPrizePopup },
          on: {
            close: function ($event) {
              _vm.showPrizePopup = false
            },
          },
        },
        [
          _vm.prizeResultName
            ? _c("div", { staticClass: "lottery-prize-result" }, [
                _c("p", { staticClass: "lottery-prize-name" }, [
                  _vm._v(_vm._s(_vm.prizeResultName)),
                ]),
                _c("p", { staticClass: "lottery-prize-tip" }, [
                  _vm._v(_vm._s(_vm.$t("claim_success_text"))),
                ]),
              ])
            : _c("div", { staticClass: "lottery-popup-tip" }, [
                _c("p", { staticClass: "lottery-tip-text" }, [
                  _vm._v(_vm._s(_vm.popupTip)),
                ]),
              ]),
        ]
      ),
      _c(
        "LotteryPrizePopup",
        {
          attrs: { visible: _vm.showRecordPopup },
          on: {
            close: function ($event) {
              _vm.showRecordPopup = false
            },
          },
        },
        [
          _c("div", { staticClass: "lottery-record" }, [
            _c("div", { staticClass: "lottery-record-title" }, [
              _vm._v(_vm._s(_vm.$t("lottery_record_title"))),
            ]),
            _vm.recordList.length === 0
              ? _c("div", { staticClass: "lottery-record-empty" }, [
                  _vm._v(_vm._s(_vm.$t("lottery_record_empty"))),
                ])
              : _c("div", { staticClass: "lottery-record-scroll" }, [
                  _c("table", { staticClass: "lottery-record-table" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("lottery_record_time"))),
                        ]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("lottery_record_prize"))),
                        ]),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      _vm._l(_vm.recordList, function (record, index) {
                        return _c("tr", { key: record.id || index }, [
                          _c("td", [_vm._v(_vm._s(record.time))]),
                          _c("td", [_vm._v(_vm._s(record.rewardName))]),
                        ])
                      }),
                      0
                    ),
                  ]),
                ]),
          ]),
        ]
      ),
      _c("transition", { attrs: { name: "rule-fade" } }, [
        _vm.showRulePopup
          ? _c(
              "div",
              {
                staticClass: "lottery-rule-overlay",
                on: {
                  click: function ($event) {
                    if ($event.target !== $event.currentTarget) return null
                    _vm.showRulePopup = false
                  },
                },
              },
              [
                _c("div", { staticClass: "lottery-rule-popup" }, [
                  _c("img", {
                    staticClass: "lottery-rule-close",
                    attrs: { src: require("./closure.png"), alt: "" },
                    on: {
                      click: function ($event) {
                        _vm.showRulePopup = false
                      },
                    },
                  }),
                  _c("div", { staticClass: "lottery-rule-title" }, [
                    _c("img", {
                      staticClass: "lottery-rule-title-image",
                      attrs: { src: require("./Rule_box_title.png"), alt: "" },
                    }),
                    _c("span", { staticClass: "lottery-rule-title-text" }, [
                      _vm._v(_vm._s(_vm.$t("lottery_rule_popup_title"))),
                    ]),
                  ]),
                  _c("div", { staticClass: "lottery-rule-body" }, [
                    _c("div", { staticClass: "lottery-rule-scroll" }, [
                      _vm._v(_vm._s(_vm.ruleText)),
                    ]),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }